import React from 'react'
import { posts } from '../data/posts';
import Card from '../components/Card/Card.js'
import './Home.css'
const Home = () => {
  return (
    <div className='post-container'>
            {posts.map((post, index) => (
                <Card
                    key={index}
                    image={post.image}
                    name={post.name}
                    url={`/post/${index + 1}`} // Sets the `url` prop to `/post/1`, `/post/2`, etc.
                />
            ))}
        </div>
  )
}

export default Home